import { AutocompleteResponse } from "../../types/here-maps/autocomplete.type";

export const mockAddresses = {
  empty: { items: [] },
  default: {
    items: [
      {
        title: "United States, CA, Los Angeles, E 123rd St",
        id: "here:af:street:RYkXJLNN22BI4zmmrBIktB",
        language: "en",
        resultType: "street",
        address: {
          label: "E 123rd St, Los Angeles, CA 90059, United States",
          countryCode: "USA",
          countryName: "United States",
          stateCode: "CA",
          state: "California",
          county: "Los Angeles",
          city: "Los Angeles",
          district: "Willowbrook",
          street: "E 123rd St",
          postalCode: "90059",
        },
        distance: 51089,
        highlights: {
          title: [
            {
              start: 34,
              end: 37,
            },
          ],
          address: {
            label: [
              {
                start: 2,
                end: 5,
              },
            ],
            street: [
              {
                start: 2,
                end: 5,
              },
            ],
          },
        },
      },
      {
        title: "United States, CA, Los Angeles, W 123rd St",
        id: "here:af:street:d2ZN9Hij1IMLC9Ga6Y3NaB",
        language: "en",
        resultType: "street",
        address: {
          label: "W 123rd St, Los Angeles, CA, United States",
          countryCode: "USA",
          countryName: "United States",
          stateCode: "CA",
          state: "California",
          county: "Los Angeles",
          city: "Los Angeles",
          street: "W 123rd St",
        },
        distance: 55156,
        highlights: {
          title: [
            {
              start: 34,
              end: 37,
            },
          ],
          address: {
            label: [
              {
                start: 2,
                end: 5,
              },
            ],
            street: [
              {
                start: 2,
                end: 5,
              },
            ],
          },
        },
      },
      {
        title: "United States, CA, Pearblossom, 123rd St E",
        id: "here:af:street:p9tDo66DcEuBevfLubJL.D",
        language: "en",
        resultType: "street",
        address: {
          label: "123rd St E, Pearblossom, CA 93553, United States",
          countryCode: "USA",
          countryName: "United States",
          stateCode: "CA",
          state: "California",
          county: "Los Angeles",
          city: "Pearblossom",
          street: "123rd St E",
          postalCode: "93553",
        },
        distance: 43001,
        highlights: {
          title: [
            {
              start: 32,
              end: 35,
            },
          ],
          address: {
            label: [
              {
                start: 0,
                end: 3,
              },
            ],
            street: [
              {
                start: 0,
                end: 3,
              },
            ],
          },
        },
      },
      {
        title: "United States, CA, Hawthorne, W 123rd St",
        id: "here:af:street:SsgwXhSV.1vsnbjOGPlGjC",
        language: "en",
        resultType: "street",
        address: {
          label: "W 123rd St, Hawthorne, CA 90250, United States",
          countryCode: "USA",
          countryName: "United States",
          stateCode: "CA",
          state: "California",
          county: "Los Angeles",
          city: "Hawthorne",
          street: "W 123rd St",
          postalCode: "90250",
        },
        distance: 61678,
        highlights: {
          title: [
            {
              start: 32,
              end: 35,
            },
          ],
          address: {
            label: [
              {
                start: 2,
                end: 5,
              },
            ],
            street: [
              {
                start: 2,
                end: 5,
              },
            ],
          },
        },
      },
      {
        title: "United States, CA, Hawthorne, W 123rd Pl",
        id: "here:af:street:pJOShLSp-GES8a4yzpM-0B",
        language: "en",
        resultType: "street",
        address: {
          label: "W 123rd Pl, Hawthorne, CA 90250, United States",
          countryCode: "USA",
          countryName: "United States",
          stateCode: "CA",
          state: "California",
          county: "Los Angeles",
          city: "Hawthorne",
          street: "W 123rd Pl",
          postalCode: "90250",
        },
        distance: 61705,
        highlights: {
          title: [
            {
              start: 32,
              end: 35,
            },
          ],
          address: {
            label: [
              {
                start: 2,
                end: 5,
              },
            ],
            street: [
              {
                start: 2,
                end: 5,
              },
            ],
          },
        },
      },
    ],
  },
} as const satisfies Record<string, AutocompleteResponse>;
